import { render, staticRenderFns } from "./ConsultantLogin.vue?vue&type=template&id=4ef90f0a&"
import script from "./ConsultantLogin.vue?vue&type=script&lang=js&"
export * from "./ConsultantLogin.vue?vue&type=script&lang=js&"
import style0 from "./ConsultantLogin.vue?vue&type=style&index=0&id=4ef90f0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports